// extracted by mini-css-extract-plugin
export default {"FAQ":"FAQ-module--FAQ--Dmi7R","FAQWrapper":"FAQ-module--FAQWrapper--F0YYH","Questions":"FAQ-module--Questions--Pc8b9","Title":"FAQ-module--Title--5e1iA"};